// import 'amfe-flexible';
// import 'lib-flexible/flexible.js'
// import './util/rem';
import 'lib-flexible'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
Vue.use(Vant);
import 'vant/lib/index.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

/* 路由发生变化修改页面 title 与 description */
function setMeta(name, content) {
  let el = document.querySelector('meta[name="' + name + '"]')
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

router.beforeEach((to, from, next) => {
  if ( to.matched.length==0 ) {
    next({ path: '/' })
  } else {
    if ( to.meta.title ) {
      document.title = to.meta.title + '- 班尼戈（中国）'
      // 站点是单页应用，description 不跟着换的话所有页面在搜索结果里都是同一段摘要
      setMeta('description', to.meta.description || (to.meta.title + ' —— 班尼戈（中国）官方网站'))
    }
    next()
  }  
})
// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap,{
//   ak:'G78xWFVNxMvxiC7ltMMb0iDCGZGtnuMO'
// })
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
